import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  getCheckoutLink,
  GetCheckoutLinkParams,
} from "@/api/v1-jwt/checkout/checkout";
import checkoutQueryKeys from "./query-keys";

export const useGetCheckoutLink = (
  params: GetCheckoutLinkParams,
  options?: Omit<UseQueryOptions<string, Error>, "queryKey" | "queryFn">
) => {
  return useQuery<string, Error>({
    queryKey: checkoutQueryKeys.links(params.userId),
    queryFn: () => getCheckoutLink(params),
    enabled: !!params.userId,
    retry: false, // Don't retry if link doesn't exist (404)
    ...options,
  });
};
